import * as systemRoles from '../../../constants/system-roles';
import { UserTiers } from '../../../constants/userTiers';

export const ROLES_MAP = {
  [UserTiers.Org]: [systemRoles.ORG_COORDINATOR, systemRoles.ORG_SPONSOR],
  [UserTiers.OrgUnit]: [systemRoles.ORG_UNIT_COORDINATOR, systemRoles.ORG_UNIT_SPONSOR]
};
